import transform from '../../utils/ResponseTransformator'
import mapResponseToTemplates from './mappers/mapResponseToTemplates'
import { IData } from './fetchTemplates'

export default function(api: GlobalFetch) {
  return async function(lang: string) {
    const response = await api.fetch(`/api/v2/template/default/lang/${lang}`, {
      method: 'GET',
    })
    let text: string = await response.text()
    text = transform(text)
    const responseBody: IData = JSON.parse(text)

    return mapResponseToTemplates(responseBody)
  }
}
